<template>
  <div class="video-inner">
    <b-container class="video-container">
      <div class="double-demo">
        <div class="circle xs"></div>
        <div class="circle sm"></div>
        <div class="circle xl"></div>
        <b-container>
          <b-row>
            <b-col class="col" lg="6" v-for="video in videos" :key="video.id">
              <div class="inner">
                <h2 v-html="video.title"></h2>
                <VideoModal v-bind="video"></VideoModal>
              </div>
            </b-col>
          </b-row>
          <div class="text-center">
            <DemoModal v-bind="demo"></DemoModal>
          </div>
        </b-container>
      </div>
    </b-container>
  </div>
</template>

<script>
import VideoModal from "./video";
import DemoModal from "./demo-modal";

export default {
  components: {
    VideoModal,
    DemoModal
  },
  props: {
    videos: Array,
    demo: Object
  }
};
</script>